import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  LISTING_WITHDRAWAL_REASON_LEASED,
} from 'common/listingConstants';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_TRANSPARENT_RED_BORDER,
} from 'client/components/SrButton/SrButton';
import SrPartnerListingWithdrawDateModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawDateModal';
import SrPartnerListingWithdrawReasonModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawReasonModal';
import SrPartnerListingWithdrawRemoveItemsModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawRemoveItemsModal';
import SrPartnerListingWithdrawChooseItemsModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawChooseItemsModal';

import './SrPartnerListingWithdrawCard.less';

const MODAL_ID_WITHDRAWAL_REASON = 'MODAL_ID_WITHDRAWAL_REASON';
const MODAL_ID_REMOVE_ITEMS = 'MODAL_ID_REMOVE_ITEMS';
const MODAL_ID_CHOOSE_ITEMS = 'MODAL_ID_CHOOSE_ITEMS';
const MODAL_ID_WITHDRAWAL_DATE = 'MODAL_ID_WITHDRAWAL_DATE';

const SrPartnerListingWithdrawCard = ({
  listing,
  partner,
  onWithdrawn,
}) => {
  const [modalId, setModalId] = useState(null);
  const [withdrawalValues, setWithdrawalValues] = useState({});
  const [itemsToUninstall, setItemsToUninstall] = useState([]);
  const [inProgress, setInProgress] = useState(false);

  const onWithdrawListing = async (payload) => {
    if (inProgress) {
      return;
    }

    setInProgress(true);

    await onWithdrawn({
      listingId: listing.id,
      itemsToUninstall,
      ...withdrawalValues,
      ...payload,
    });
  };

  const onSubmitWithdrawalReasonForm = (formValues) => {
    setWithdrawalValues(formValues);
    setModalId(MODAL_ID_REMOVE_ITEMS);
  };

  const onSubmitRemoveItemsForm = async (formValues) => {
    if (formValues.uninstallItems) {
      setModalId(MODAL_ID_CHOOSE_ITEMS);
    }
    else {
      await onWithdrawListing({
        itemsToUninstall: [],
      });
    }
  };

  const onSubmitChooseItemsForm = async (formValues) => {
    if (withdrawalValues.withdrawalReason === LISTING_WITHDRAWAL_REASON_LEASED) {
      await onWithdrawListing({
        itemsToUninstall: formValues.itemsToUninstall,
      });
    }
    else {
      setItemsToUninstall(formValues.itemsToUninstall);
      setModalId(MODAL_ID_WITHDRAWAL_DATE);
    }
  };

  const onSubmitWithdrawalDateForm = async (formValues) => {
    await onWithdrawListing({
      date: formValues.date,
    });
  };

  return (
    <div styleName='cardContainer'>
      <span styleName='cardTitle'>
        Withdraw Listing
      </span>
      <span styleName='cardDescription'>
        Choose a reason to withdraw this listing, and optionally request an uninstall of items
      </span>
      <SrButton
        theme={SR_BUTTON_THEME_ADOBE_TRANSPARENT_RED_BORDER}
        onClick={() => {
          setModalId(MODAL_ID_WITHDRAWAL_REASON);
        }}
      >
        Withdraw
      </SrButton>
      {modalId === MODAL_ID_WITHDRAWAL_REASON && (
        <SrPartnerListingWithdrawReasonModal
          partner={partner}
          onClose={() => {
            setModalId(null);
          }}
          onSubmit={onSubmitWithdrawalReasonForm}
        />
      )}
      {modalId === MODAL_ID_REMOVE_ITEMS && (
        <SrPartnerListingWithdrawRemoveItemsModal
          onClose={() => {
            setModalId(MODAL_ID_WITHDRAWAL_REASON);
          }}
          onSubmit={onSubmitRemoveItemsForm}
        />
      )}
      {modalId === MODAL_ID_CHOOSE_ITEMS && (
        <SrPartnerListingWithdrawChooseItemsModal
          onClose={() => {
            setModalId(MODAL_ID_WITHDRAWAL_REASON);
          }}
          onSubmit={onSubmitChooseItemsForm}
        />
      )}
      {modalId === MODAL_ID_WITHDRAWAL_DATE && (
        <SrPartnerListingWithdrawDateModal
          onClose={() => {
            setModalId(MODAL_ID_WITHDRAWAL_REASON);
          }}
          onSubmit={onSubmitWithdrawalDateForm}
        />
      )}
    </div>
  );
};

SrPartnerListingWithdrawCard.propTypes = {
  listing: PropTypes.object.isRequired,
  partner: PropTypes.object.isRequired,
  onWithdrawn: PropTypes.func.isRequired,
};

SrPartnerListingWithdrawCard.displayName = 'SrPartnerListingWithdrawCard';

export default SrPartnerListingWithdrawCard;
